import React from 'react';

import style from './styles.module.scss';

export default function ComaComponent({ dark, className }) {
    return (
        <svg className={`${style.svg} ${dark ? style['svg--dark'] : ''} ${className ? className : ''}`} xmlns="http://www.w3.org/2000/svg" width="80" height="64" viewBox="0 0 80 64">
            <g fill="none" fillRule="evenodd">
                <path d="M0 0H80V64H0z"/>
                <path className={style.path} d="M45.2 1.397c3.8 0 7.6-.2 10.8-.397-4.398 15.657-14.2 49.549-17.4 61.44-3.6-.99-10.401-2.775-14.6-3.568C27.399 45.196 33 16.062 35 1c3.2.198 6.6.397 10.2.397"/>
            </g>
        </svg>
    );
}